import React, { FormEvent, useState } from 'react';
import { useRouter } from 'next/router';
import { Search } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';

interface ItemFilterProps {
  onSearch?: (searchTerm: string) => void;
  label: string;
  placeHolder?: string;
  setSearch?: (value: string) => void;
}

const ItemFilter: React.FC<ItemFilterProps> = ({
  onSearch,
  label,
  placeHolder,
  setSearch,
}) => {
  const router = useRouter();
  const { search }: { search?: string } = router.query;
  const isNotBrandModal = label !== 'Pesquise por marcas';

  const [searchTerm, setSearchTerm] = useState(
    (isNotBrandModal && search) || ''
  );

  const handleSearch = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSearch && onSearch(searchTerm);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSearch}
      sx={{
        backgroundColor: '#FFF',
        borderRadius: '12px',
        padding: 2,
      }}
    >
      <TextField
        label={label}
        placeholder={placeHolder}
        name="code"
        fullWidth
        variant="outlined"
        sx={{ '& .MuiFormLabel-root': { paddingRight: '40px' } }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton type="submit">
                <Search />
              </IconButton>
            </InputAdornment>
          ),
          inputProps: {
            maxLength: 256,
          },
        }}
        value={searchTerm}
        //Remove all URI reserved caracters from search filter value
        onChange={e => {
          setSearch && setSearch(e.target.value),
            setSearchTerm(e.target.value.replace(/[#&,]/g, ''));
        }}
      />
    </Box>
  );
};

export default ItemFilter;
